const compositionOptions = [
  {
    key: "standard-panel",
    label: "Standard Panel",
    value: "standard-panel",
    models: "Claude, ChatGPT, Gemini",
    roles: {
      advocate: "Claude",
      critic: "ChatGPT",
      strategist: "Gemini",
    },
    roleBackups: {
      advocate: ["Grok"],
      critic: ["Grok"],
      strategist: ["Grok"],
    },
  },
  {
    key: "adversarial-panel",
    label: "Adversarial Panel",
    value: "adversarial-panel",
    models: "Claude, Grok, Perplexity",
    roles: {
      advocate: "Claude",
      critic: "Grok",
      strategist: "Perplexity",
    },
    roleBackups: {
      advocate: ["ChatGPT"],
      critic: ["ChatGPT"],
      strategist: ["ChatGPT"],
    },
  },
];

export default compositionOptions;
